// extracted by mini-css-extract-plugin
module.exports = {"footer":"FileParser_footer__18A6G"};